import { DictionaryOfRefundableDepositKeyPhrases, refundableStatuses } from '../constants';
import isKeywordsInDescription from './isKeywordsInDescription';

const getCruiseRateRefundability = (rateOptionRules) => {
  let isRefundable;
  let isNoRefundable;
  if (rateOptionRules) {
    isNoRefundable = isKeywordsInDescription(
      DictionaryOfRefundableDepositKeyPhrases.nonRefundable,
      rateOptionRules,
    );
    if (!isNoRefundable) {
      isRefundable = isKeywordsInDescription(
        DictionaryOfRefundableDepositKeyPhrases.refundable,
        rateOptionRules,
      );
    }
  }
  let refundableStatus = isNoRefundable
    ? refundableStatuses.NON_REFUNDABLE
    : refundableStatuses.REFUNDABLE;

  refundableStatus =
    !isRefundable && !isNoRefundable ? refundableStatuses.NO_INFO : refundableStatus;

  return refundableStatus;
};

export default getCruiseRateRefundability;
